import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Customers from "../../../assets/customers.webp";
import BgImage from "../../../assets/header-bg.webp";
import { Link } from "react-scroll";

const HeaderContent = () => {
  return (
    <header className="header">
        <img src={BgImage} alt="Header" />
        <div className="inner">
            <div className="content">
                <h1>
                Enhance and Scale Your Business with Innovative and Effective{" "}
                <span>Software Solutions</span>
                </h1>
                <p>
                We deliver cost effective custom software development and top-tier IT
                solutions, tailored to meet your business needs.
                </p>
            </div>
            <div className="btn-rate">
                <Link to={"schedule"} spy={true} smooth={true} offset={-100} duration={2000} >
                    <button type="button">Schedule A Call With Us</button>
                </Link>
                <div className="rate">
                    <CheckCircleIcon className="rate-icon" />
                    <p>99% Customer Satisfaction Rate</p>
                </div>
                <div className="customer-slide-down">
                    <img src={Customers} alt="rate" />

                    <Link to={"services"} spy={true} smooth={true} offset={-160} duration={500} >
                        <div className='slide-down'>
                            <ExpandMoreIcon className="slide-icon" />
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    </header>
  )
}

export default HeaderContent;